module.exports = __webpack_public_path__ + "static/img/2.c9ed0c4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/2.png
// module id = 480
// module chunks = 1